export default function useAddressHelpers(): any {
  function duplicateWordCheckandFormat(addressLine2: string) {
    const re = /(\b\w+\b)(?=.*\b\1\b)/gi;
    const valid = re.test(addressLine2);
    return valid;
  }

  function getAddressUnitTypeAbbreviation(addressLine2: string) {
    const space = addressLine2.indexOf(" ");
    const textModified = addressLine2.substring(0, space > 0 ? space : addressLine2.length);
    return textModified;
  }

  function getPrefix(str: string, substrings: string[]) {
    for (let i = 0; i != substrings.length; i++) {
      const substring = substrings[i];
      if (str.indexOf(substring) != -1) {
        return substring;
      }
    }
    return null;
  }

  function removePrefixString(str: string, strToRemove: string) {
    return str ? str?.replace(strToRemove, "") : str;
  }

  function removePrefix(str: string, substrings: string[]) {
    if (str) {
      let newStr;
      substrings.forEach((i: any) => {
        if (str.includes(i)) {
          const string = str.replace(i, " ");
          newStr = string.trimStart();
        }
      });
      return newStr || str;
    }
  }

  return {
    getPrefix,
    removePrefix,
    removePrefixString,
    getAddressUnitTypeAbbreviation,
    duplicateWordCheckandFormat,
  };
}
